import React from 'react';
import {
  Atom,
  type AtomRenderProps,
  type StyleAttributeObject,
} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const emptyObject: Record<string, any> = {};
const setDisplayBlock = (style: StyleAttributeObject) => {
  if (style.display === 'block') {
    return style;
  }
  return {
    ...style,
    display: 'block',
  };
};

const FormErrorMessage = Atom.createRender(
  ({
    attributes,
    classes,
    generateAttributes,
    data,
    renderChild,
    context,
  }: AtomRenderProps) => {
    const errorMessageClasses = classes.push('w-form-fail');

    const props = generateAttributes(attributes, errorMessageClasses);
    const finalProps =
      context.get('formState') === 'error'
        ? {
            ...props,
            style: setDisplayBlock(props.style || emptyObject),
          }
        : props;

    return (
      <div {...finalProps}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </div>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Error Message',
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'The display setting can’t be changed for a form’s success message.',
    },
  },
  render: FormErrorMessage,
  fields: {children: TListOfElement},
});

export default config;
